<template>
  <v-dialog
    v-model="rejectDialog"
    max-width="600px"
    content-class="rv-reject-dialog"
    @click:outside="closeRejectDialog()"
  >
    <v-card class="rv-reject-dialog__card">
      <div class="rv-reject-dialog__header">
        <v-icon class="rv-reject-dialog__header-icon" color="white" size="22">mdi-close-circle-outline</v-icon>
        <span class="rv-reject-dialog__header-title">Reject Refund to Finance AR</span>
      </div>

      <v-form lazy-validation>
        <div class="rv-reject-dialog__body">
          <label class="rv-reject-dialog__label">
            <span class="rv-reject-dialog__required">*</span>
            Please confirm if you wish to reject the refund & add a remarks:
          </label>
          <div class="rv-reject-dialog__textarea-wrap">
            <v-textarea
              filled
              no-resize
              name="input-7-4"
              v-model="formData.rejectReason"
              :error-messages="errorField.rejectReason"
              class="rv-reject-dialog__textarea"
              placeholder="Enter rejection reason..."
              hide-details="auto"
            ></v-textarea>
          </div>
        </div>

        <div class="rv-reject-dialog__actions">
          <button
            type="button"
            class="rv-reject-dialog__btn rv-reject-dialog__btn--cancel"
            @click="closeRejectDialog()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="rv-reject-dialog__btn rv-reject-dialog__btn--confirm"
            @click="rejectApplicationToAR()"
          >
            Confirm Reject
          </button>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/objects/api";
import { mapState } from "vuex";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";

export default {
  mixins: [hrdcFunction],
  name: "ApApplicationSelection",
  emits: ["rejectApplicationToAR", "closeRejectDialog"],
  data: () => ({
    api: new Api(),
    service: new Service(),
    isLoading: false,
    dialog: false,
    menu: false,
    modal: false,
    menu2: false,
    hrdcData: new HrdcData(),
  }),
  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
  }),
  props: {
    rejectDialog: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    errorField: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectApplicationToAR() {
      this.$emit("rejectApplicationToAR", this.formData);
    },
    closeRejectDialog() {
      this.$emit("closeRejectDialog");
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-reject-dialog__label {
  color: var(--app-text);
}

.dark-mode .rv-reject-dialog__btn--cancel {
  background: var(--app-card);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .rv-reject-dialog__btn--cancel:hover {
  background: var(--app-surface);
}

/* >>> end auto-dark <<< */

/* Reject dialog card */
.rv-reject-dialog__card {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

/* Header */
.rv-reject-dialog__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 24px;
  background: #ef4444;
}

.rv-reject-dialog__header-icon {
  flex-shrink: 0;
}

.rv-reject-dialog__header-title {
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

/* Body */
.rv-reject-dialog__body {
  padding: 24px;
}

.rv-reject-dialog__label {
  display: block;
  font-family: 'Lato', sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  color: #334155;
  margin-bottom: 12px;
  line-height: 1.5;
}

.rv-reject-dialog__required {
  color: #ef4444;
  font-weight: 700;
  margin-right: 2px;
}

.rv-reject-dialog__textarea-wrap {
  border-radius: 10px;
  overflow: hidden;
}

/* Actions */
.rv-reject-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 24px 20px;
}

.rv-reject-dialog__btn {
  padding: 10px 28px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.rv-reject-dialog__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.rv-reject-dialog__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.rv-reject-dialog__btn--confirm {
  background: #ef4444;
  color: #fff;
  border: none;
}

.rv-reject-dialog__btn--confirm:hover {
  background: #dc2626;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

@media (max-width: 599px) {
  .rv-reject-dialog__header {
    padding: 14px 18px;
  }

  .rv-reject-dialog__body {
    padding: 16px;
  }

  .rv-reject-dialog__label {
    font-size: 0.78rem;
  }

  .rv-reject-dialog__actions {
    padding: 0 16px 16px;
    flex-wrap: wrap;
  }

  .rv-reject-dialog__btn {
    flex: 1;
    text-align: center;
    justify-content: center;
    padding: 10px 16px;
    font-size: 0.82rem;
  }
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-reject-dialog__textarea .v-input__slot {
  background: var(--app-card) !important;
  border: 1.5px solid var(--app-border) !important;
}

.dark-mode .rv-reject-dialog__textarea textarea {
  color: var(--app-text) !important;
}

.dark-mode .rv-reject-dialog__textarea textarea::placeholder {
  color: var(--app-text-faint) !important;
}

/* >>> end auto-dark <<< */

/* Reject dialog rounded override */
.rv-reject-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

/* Textarea styling override */
.rv-reject-dialog__textarea .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 10px !important;
  min-height: 120px !important;
}

.rv-reject-dialog__textarea .v-input__slot::before,
.rv-reject-dialog__textarea .v-input__slot::after {
  display: none !important;
}

.rv-reject-dialog__textarea textarea {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.9rem !important;
  color: #334155 !important;
  padding: 12px 14px !important;
}

.rv-reject-dialog__textarea textarea::placeholder {
  color: #94a3b8 !important;
}

.rv-reject-dialog__textarea .v-input__slot:hover {
  border-color: #56bde8 !important;
}

.rv-reject-dialog__textarea .v-input__slot:focus-within {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.1) !important;
}
</style>
